import { EventEmitter } from 'events';

import { createContext, useContext } from 'react';

export const BusContext = createContext<EventEmitter>(null!);

export const useBus = () => useContext(BusContext);
